// context/LoginContext.tsx (简化版)
import LoginModal from '@/components/Login';
import React, { createContext, useContext, useRef, useState } from 'react';
import { profile } from '@/request/api';
import { store } from '@/store';

interface LoginContextType {
  showLogin: () => Promise<boolean>;
}

// 简单的全局访问点
let globalShowLogin: (() => Promise<boolean>) | null = null;

const LoginContext = createContext<LoginContextType | null>(null);

export const LoginProvider = ({ children }: { children: React.ReactNode }) => {
  const [visible, setVisible] = useState(false);
  const resolveRef = useRef<(value: boolean) => void>();

  const fetchUserInfo = async () => {
    const response = await profile({});
    if (response.code === 200) {
      store.dispatch({
        type: 'update-userInfo',
        payload: { userInfo: response.data.profile },
      });
    }
  };

  const showLogin = (): Promise<boolean> => {
    setVisible(true);
    return new Promise((resolve) => {
      resolveRef.current = resolve;
    });
  };

  // 注册到全局
  React.useEffect(() => {
    globalShowLogin = showLogin;
    return () => {
      globalShowLogin = null;
    };
  }, []);

  const handleSuccess = async () => {
    await fetchUserInfo();
    setVisible(false);
    resolveRef.current?.(true);
    resolveRef.current = undefined;
  };

  const handleClose = () => {
    setVisible(false);
    resolveRef.current?.(false);
    resolveRef.current = undefined;
  };

  return (
    <LoginContext.Provider value={{ showLogin }}>
      {children}
      <LoginModal
        visible={visible}
        onSuccess={handleSuccess}
        onClose={handleClose}
      />
    </LoginContext.Provider>
  );
};

export const useLogin = (): LoginContextType => {
  const context = useContext(LoginContext);
  if (!context) throw new Error('useLogin must be used within LoginProvider');
  return context;
};

// 导出给拦截器使用的函数
export const getGlobalLogin = () => globalShowLogin;
